import { render, staticRenderFns } from "./IrStatements.vue?vue&type=template&id=98e22d9c&"
import script from "./IrStatements.vue?vue&type=script&lang=js&"
export * from "./IrStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports